export const intro = {
  title: "Fractional Crewing Solutions",
  body: "At Access Crewing Solutions, we specialise in delivering flexible, efficient, and comprehensive support for offshore crewing and logistics needs. With a strong focus on the oil, gas, and renewable energy sectors, we are your trusted partner for ensuring seamless operations and optimal crew management. Our approach combines industry expertise, tailored solutions, and a commitment to excellence, allowing your organisation to focus on achieving its strategic goals while we handle the operational details.",
};

export const ourProcess = {
  title: "Our Process",
  content: [
    {
      title: "Evaluation",
      body: "Continuous feedback and adjustments to optimise results.",
    },
    {
      title: "Discovery",
      body: "We work closely with you to understand your unique needs and operational challenges.",
    },
    {
      title: "Customisation",
      body: "Our team develops a tailored plan, ensuring alignment with your objectives.",
    },
    {
      title: "Implementation",
      body: "We execute the plan with precision, keeping you informed every step of the way.",
    },
  ],
};

export const ourServices = {
  title: "Our Services",
  content: [
    {
      title: "Crewing and Recruitment",
      body: "We source and recruit highly skilled professionals tailored to the demands of your offshore projects. Our comprehensive service includes:",
      subContent: [
        "Identifying, interviewing, and onboarding qualified crew members.",
        "Managing compliance with certifications and industry standards as per regulatory bodies.",
        "Ensuring a streamlined recruitment process that saves you time and resources.",
      ],
    },
    {
      title: "Crew Compliance & Training",
      body: "Keeping your crew compliant and skilled is critical to operational success. We provide:",
      subContent: [
        "Certification tracking and management to ensure all requirements are met.",
        "Coordination of mandatory medical checks and specialised industry training.",
        "Development of customised training pathways to enhance crew capabilities.",
      ],
    },
    {
      title: "Documentation & Data",
      body: "Efficient and secure management of your operational and crew-related documentation is crucial. Our enhanced focus on data and administration includes:",
      subContent: [
        "Securely storing, organising, and maintaining all essential documents for easy access and retrieval.",
        "Regular reviews to ensure all permits, and certifications meet industry standards and legal requirements.",
        "Automated alerts for document renewals, expirations, or changes, ensuring nothing is overlooked.",
        "Streamlined workflows for managing crew-related administrative tasks, reducing manual effort and errors.",
      ],
    },
    {
      title: "Logistics & Operations",
      body: "We ensure smooth and efficient logistics for your crew. Our services include:",
      subContent: [
        "Booking and coordinating cost-effective, high-quality travel and lodging arrangements tailored to the specific requirements of offshore assignments.",
        "Seamless scheduling and execution of crew mobilisation and demobilisation to ensure uninterrupted operations.",
        "Managing all necessary documentation and approvals, including visas and related travel documents, with strict adherence to legal and regulatory requirements.",
      ],
    },
  ],
};

export const summary = {
  title: "Experience the Difference",
  body: "Contact us now to find out more about our flexible services within project management and crewing.",
  cta: { text: "Enquire Today", url: "/contact" },
};
